import { pushRoute } from '../../lib/router.js';
import React, { useEffect } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import AuthorizedAction, {
  isAuthorized,
  isUnAuthorized,
} from '../../components/AuthorizedAction.js';
import { loadingContent } from '../../components/EmptyStates.jsx';
import UserActionsDropdown from '../../components/organizations/Users/UserActionsDropdown.jsx';
import Empty from '../../components/Empty.jsx';
import OrganizationHeader from '../../components/headers/PageHeaders/Organization/OrganizationHeader.jsx';
import UserSubHeaderInfo from '../../components/organizations/Users/UserSubHeaderInfo.jsx';
import SubHeader from '../../components/SubHeader.jsx';
import { PermissionsLink } from '../../components/links/index.jsx';
import {
  selectUser as selectCurrentUser,
  selectUserPermissions,
  selectUserRestrictions,
  signOut,
} from '../../modules/auth.js';
import { deleteUser, retrieveUser, selectUser } from '../../modules/users.js';
import { mapFinalFormErrors } from '../../lib/utils.js';

const mapStateToProps = (state, ownProps) => ({
  userId: ownProps.userId,
  currentUser: selectCurrentUser(state),
  user: selectUser(ownProps.userId)(state),
  restrictions: selectUserRestrictions(state),
  permissions: selectUserPermissions(state),
});

const mapErrors = mapFinalFormErrors('Failed to delete user');

const mapDispatchToProps = { retrieveUser, deleteUser, signOut };

const UserContainer = ({
  userId,
  user,
  restrictions,
  retrieveUser,
  currentUser,
  deleteUser,
  signOut,
  permissions,
}) => {
  const onDelete = () => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      const submitPromise = deleteUser(userId);

      submitPromise
        .then(() => pushRoute('organization/users'))
        .catch(mapErrors);
    }
  };

  const isBlockedDeletedUser = isUnAuthorized(
    'destroy',
    'userOrganizationRole',
    restrictions
  );

  useEffect(() => {
    retrieveUser(userId);
  }, [userId]);

  return user ? (
    <React.Fragment>
      <OrganizationHeader
        profileTabs
        userId={userId}
        currentUserId={currentUser.id}
        employeeId={user.employeeId}
        userName={user.fullName}
        orgRole={user.orgRole}
        permissions={permissions}
      />

      <SubHeader flexJustify small>
        <UserSubHeaderInfo user={user} currentUserId={currentUser.id} />
        <UserActionsDropdown
          userId={userId}
          currentUserId={currentUser.id}
          currentUserRole={currentUser.orgRole}
          onDelete={onDelete}
          employeeId={user.employeeId}
          onSignOut={signOut}
          isBlockedDeletedUser={isBlockedDeletedUser}
          orgRole={user.orgRole}
        />
      </SubHeader>
      <Grid>
        {user.status === 'no_roles' ? (
          <Row>
            <Col sm={12}>
              <div className="flex flex-col component-xl component-bg-white component-xl-padding-vertical component-border-bottom">
                <h3 className="text-center text-danger m-b-12">
                  User added and profile created. Next, you'll need to select
                  their organization and roles using the Permissions tab.
                </h3>
                <p className="text-muted text">
                  An invitation to join ChangeSync will be sent after at least
                  one role is assigned on the Permissions tab.
                  {userId &&
                  user.employeeId &&
                  (currentUser.orgRole === 'consultant' ||
                    currentUser.orgRole === 'admin' ||
                    isAuthorized('create', 'userProjectRole', permissions)) ? (
                    <AuthorizedAction action="read" subject="user">
                      <PermissionsLink userId={userId}>
                        <a className="m-l-4">Manage User Permissions</a>
                      </PermissionsLink>
                    </AuthorizedAction>
                  ) : null}
                </p>
              </div>
            </Col>
          </Row>
        ) : null}

        <Row>
          <Col sm={12}>
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <Row>
                    <Col sm={3} md={2}>
                      <h3 className="flex m-b-32">Information</h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={3} md={2}>
                      <div className="text-muted m-b-32">First Name</div>
                      <div className="text-muted m-b-32">Last Name</div>
                      <div className="text-muted m-b-32">Email</div>
                    </Col>
                    <Col sm={9} md={10}>
                      <div className="m-b-32">{user.firstName}</div>
                      <div className="m-b-32">{user.lastName}</div>
                      <div className="m-b-32">{user.email}</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    </React.Fragment>
  ) : (
    <Empty simplified content={loadingContent} />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserContainer);
